export default "assets/images/icons/cabinet-3cd1fc62.svg";